<template>
  <div>
    <!-- Desktop Header -->
    <header class="bg-white border-b border-neutral-100 hidden md:block">
      <div class="px-6 lg:px-10 py-2 flex items-center justify-between">
        <!-- Logo -->
        <a :href="`${Globals.APP_HOME_URL}/`" class="flex-shrink-0">
          <img src="@/assets/images/logo.png" alt="Akademia Improwizacji" class="h-9" />
        </a>
        
        <!-- Navigation -->
        <nav class="flex items-center gap-6 lg:gap-8">
            <a :href="`${Globals.APP_HOME_URL}/kursy-improwizacji/`" class="text-sm text-neutral-600 hover:text-neutral-950 transition-colors font-medium">Kursy improwizacji</a>
            <a :href="`${Globals.APP_HOME_URL}/warsztaty-aktorskie/`" class="text-sm text-neutral-600 hover:text-neutral-950 transition-colors font-medium">Warsztaty aktorskie</a>
            <a :href="`${Globals.APP_HOME_URL}/dla-firm/`" class="text-sm text-neutral-600 hover:text-neutral-950 transition-colors font-medium">Dla firm</a>
            <a :href="`${Globals.APP_HOME_URL}/sciezka-rozwoju/`" class="text-sm text-neutral-600 hover:text-neutral-950 transition-colors font-medium">Ścieżka rozwoju</a>
            <a :href="`${Globals.APP_HOME_URL}/o-nas/`" class="text-sm text-neutral-600 hover:text-neutral-950 transition-colors font-medium">O nas</a>
            <a :href="`${Globals.APP_HOME_URL}/kontakt/`" class="text-sm text-neutral-600 hover:text-neutral-950 transition-colors font-medium">Kontakt</a>
        </nav>


        
        <!-- User Section -->
        <div class="relative" v-if="isLoggedIn">
          <button 
            @click="userMenuOpen = !userMenuOpen"
            class="flex items-center gap-3 py-2 px-3 rounded-lg hover:bg-neutral-50 transition-colors"
          >
            <div class="w-10 h-10 bg-primary-500 rounded-full flex items-center justify-center">
              <span class="text-sm font-bold text-neutral-950">{{user.initials()}}</span>
            </div>
            <span class="text-sm text-neutral-950 font-semibold">{{user.displayName()}}</span>
            <svg class="w-4 h-4 text-neutral-600 transition-transform" :class="userMenuOpen ? 'rotate-180' : ''" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"/>
            </svg>
          </button>
          
          <!-- Dropdown Menu -->
          <div 
            v-if="userMenuOpen"
            class="absolute right-0 mt-2 w-48 bg-white border border-neutral-100 rounded-lg shadow-lg py-2 z-50"
          >
            <a href="/customer/profile" class="flex items-center gap-3 px-4 py-2 text-sm text-neutral-950 hover:bg-neutral-50 transition-colors">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
              </svg>
              Profil
            </a>
            <button @click="logout" class="flex items-center gap-3 px-4 py-2 text-sm text-neutral-950 hover:bg-neutral-50 transition-colors w-full text-left">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
              </svg>
              Wyloguj
            </button>
          </div>
        </div>
        
        <!-- Auth Buttons (Not Logged In, e.g. during login/registration) -->
        
        <!-- div class="flex items-center gap-3" v-else>
          <a href="/authorization" class="px-4 py-2 text-sm text-neutral-950 font-medium hover:text-neutral-600 transition-colors">
            Logowanie
          </a>
          <a href="/authorization" class="px-6 py-2 bg-primary-500 text-neutral-950 font-semibold rounded-lg hover:bg-primary-600 transition-colors text-sm">
            Darmowa rejestracja
          </a>
        </div -->
      </div>
    </header>

    <!-- Mobile Header -->
    <div class="flex items-center justify-between px-4 py-3 bg-white border-b border-neutral-100 md:hidden">
      <button 
        @click="mobileMenuOpen = !mobileMenuOpen"
        class="w-10 h-10 flex items-center justify-center text-neutral-950"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16"/>
        </svg>
      </button>
      
      <!-- Logo -->
      <a href="/" class="flex-shrink-0">
        <img src="@/assets/images/logo.png" alt="Akademia Improwizacji" class="h-7" />
      </a>
      
      <!-- User Avatar with Dropdown (Logged In) -->
      <button 
        v-if="isLoggedIn"
        @click="userMenuOpen = !userMenuOpen"
        class="w-10 h-10 bg-primary-500 rounded-full flex items-center justify-center"
      >
        <span class="text-sm font-bold text-neutral-950">{{ user.initials() }}</span>
      </button>
      
      <!-- Auth Button (Not Logged In) -->
      <a 
        v-else
        href="/" 
        class="px-4 py-2 bg-primary-500 text-neutral-950 font-semibold rounded-lg text-sm"
      >
        Rejestracja
      </a>
    </div>

    <!-- Mobile User Dropdown -->
    <div 
      v-if="userMenuOpen && isLoggedIn"
      class="fixed top-14 right-4 w-48 bg-white border border-neutral-100 rounded-lg shadow-lg py-2 z-50 md:hidden"
    >
          <a href="/customer/courses" class="flex items-center gap-3 px-4 py-2 text-sm text-neutral-950 hover:bg-neutral-50 transition-colors" role="menuitem">
        <svg class="w-4 h-4"  fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" d="M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342M6.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 0v-3.675A55.378 55.378 0 0 1 12 8.443m-7.007 11.55A5.981 5.981 0 0 0 6.75 15.75v-1.5" />
</svg>

        Kursy
      </a>
    
      <a href="/customer/profile" class="flex items-center gap-3 px-4 py-2 text-sm text-neutral-950 hover:bg-neutral-50">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
        </svg>
        Profil
      </a>
      <button @click="logout" class="flex items-center gap-3 px-4 py-2 text-sm text-neutral-950 hover:bg-neutral-50 w-full text-left">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
        </svg>
        Wyloguj
      </button>
    </div>

    <!-- Mobile Menu Full Screen -->
    <div 
      v-if="mobileMenuOpen"
      class="fixed inset-0 bg-white z-50 md:hidden"
    >
      <div class="flex flex-col h-full">
        <!-- Header -->
        <div class="flex items-center justify-between px-4 py-3 border-b border-neutral-100">
          <span class="text-lg font-bold text-neutral-950">Menu</span>
          <button 
            @click="mobileMenuOpen = false"
            class="w-10 h-10 flex items-center justify-center"
          >
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        
        <!-- Navigation Links -->
        <nav class="flex flex-col p-6 gap-6">
            <a :href="`${Globals.APP_HOME_URL}/kursy-improwizacji/`" @click="mobileMenuOpen = false" class="text-lg text-neutral-950 font-semibold py-3 border-b border-neutral-100">Kursy improwizacji</a>
            <a :href="`${Globals.APP_HOME_URL}/warsztaty-aktorskie/`" @click="mobileMenuOpen = false" class="text-lg text-neutral-950 font-semibold py-3 border-b border-neutral-100">Warsztaty aktorskie</a>
            <a :href="`${Globals.APP_HOME_URL}/dla-firm/`" @click="mobileMenuOpen = false" class="text-lg text-neutral-950 font-semibold py-3 border-b border-neutral-100">Dla firm</a>
            <a :href="`${Globals.APP_HOME_URL}/sciezka-rozwoju/`" @click="mobileMenuOpen = false" class="text-lg text-neutral-950 font-semibold py-3 border-b border-neutral-100">Ścieżka rozwoju</a>
            <a :href="`${Globals.APP_HOME_URL}/o-nas/`" @click="mobileMenuOpen = false" class="text-lg text-neutral-950 font-semibold py-3 border-b border-neutral-100">O nas</a>
            <a :href="`${Globals.APP_HOME_URL}/kontakt/`" @click="mobileMenuOpen = false" class="text-lg text-neutral-950 font-semibold py-3 border-b border-neutral-100">Kontakt</a>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import Globals from '@shared/model/Globals.js';
import rpAPI from '@shared/service/rpAPI.js';

export default {
  name: 'SiteHeader',
  data() {
    return {
      Globals,
      mobileMenuOpen: false,
      userMenuOpen: false,
    };
  },
  async mounted() {
    await rpAPI.ensureUser();
  },
  computed: {
    isLoggedIn() {
      return rpAPI.isLoggedIn();
    },
    user() {
      return rpAPI.user;
    },
  },
  methods: {
         getSharedCookieDomain() {
        const host = String(window.location.hostname || '').trim().toLowerCase();
        const mainDomain = String(Globals.EMAIL_DOMAIN || '').trim().toLowerCase();

        // If app is hosted on the main domain (or subdomain), share cookie for that domain.
        if (mainDomain && (host === mainDomain || host.endsWith('.' + mainDomain))) {
          return mainDomain;
        }

        // In local/dev environments, do not set Domain=... (browsers often reject it).
        if (!host || host === 'localhost' || /^[0-9.]+$/.test(host)) {
          return null;
        }

        // Fallback: use last 2 labels (works for most domains).
        const parts = host.split('.').slice(-2);
        return parts.join('.');
      },
    clearSession() {
      const secure = window.location?.protocol === 'https:';
      const domain = this.getSharedCookieDomain();
      let cookie = 'reservepro_session=; Path=/; SameSite=Lax; Expires=Thu, 01 Jan 1970 00:00:00 GMT';
      if (domain) cookie += `; Domain=${domain}`;
      if (secure) cookie += '; Secure';
      document.cookie = cookie;
        console.log('Cleared session cookie:', document.cookie);
    },
    logout() {
      rpAPI.logout();
      this.clearSession();
      window.location.href = Globals.APP_HOME_URL;
      this.userMenuOpen = false;
    },
  },
  
};
</script>
